import React from 'react';
import styled from 'styled-components';
import { Icon } from 'antd';

const CheckIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  background: #4caf50;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  z-index: 2;
`;

const ColorSelection = styled.div`
  opacity: ${p => (p.disabled ? '0.5' : '1')};
  pointer-events: ${p => (p.disabled ? 'none' : 'auto')};
  border: 2px solid ${p => (p.selected ? p?.theme?.primaryColor : '#E0E0E0')};
  border-radius: 4px;
  background: ${p => p.selected ? 'rgba(222, 203, 179, 0.3)' : 'transparent'};
  width: min-content;
  position: relative;
  border-width: ${p => (p.selected ? '4px' : '2px')};
`;

const OptionContent = styled.div`
  display: inline-block;
  align-content: center;
  justify-content: center;
  align-items: center;
  text-align: left;
  padding: 5px 10px;
  white-space: pre-line;
  cursor: pointer;
  background: ${p => (p.transparent ? 'transparent' : '#E0E0E0')};
`;

const ImageBox = styled.img`
  width: 100px;
  height: 100px;
  display: inline-block;
`;

const ColorBox = styled.div`
  display: inline-block;
  width: 100px;
  height: 100px;
  background-color: ${({ color }) => color || '#FFF'};
`;

const ColorName = styled.div`
  font-size: 14px;
`;

export const WeddingCanvaColorCard = ({ question, record, input }) => {
  const selected = input?.value && input.value.find(id => id === record._id);

  const toggleColor = (id) => {
    const list = [...input.value];
    const index = list.findIndex(x => x === id);

    if (index >= 0) list.splice(index, 1);
    else list.push(id);

    input.onChange(list);
  };

  return (
    <ColorSelection selected={selected} onClick={() => toggleColor(record._id)}>
      {selected && (
        <CheckIcon>
          <Icon type='check' />
        </CheckIcon>
      )}
      <OptionContent transparent>
        {record.defaultOption && record.defaultOption.image || record.image ? (
          <ImageBox src={record.defaultOption ? record.defaultOption.image.url : record.image.url} />
        ) : (
          <ColorBox color={record.defaultOption ? record.defaultOption.hex : record.hex} />
        )}
        <ColorName>{record?.name?.pt}</ColorName>
      </OptionContent>
    </ColorSelection>
  );
};

export default WeddingCanvaColorCard;
